/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';

import {AdvertisingSharedModule} from '../advertising/advertising-shared.module';
import {CreativeModule} from '../creative/creative.module';
import {LineItemModule} from '../line-item/line-item.module';
import {OrderAnalysisPageComponent} from './order-analysis-page.component';
import {OrderBudgetModalComponent} from './order-budget-modal.component';
import {OrderCopyModalComponent} from './order-copy-modal.component';
import {OrderEditPageComponent} from './order-edit-page.component';
import {OrderInformationPageComponent} from './order-information-page.component';
import {OrderItemPageComponent} from './order-item-page.component';
import {OrderListFiltersComponent} from './order-list-filters.component';
import {OrderListPageComponent} from './order-list-page.component';
import {OrderQuickLineItemFormComponent} from './order-quick-line-item-form.component';

const ORDER_COMPONENTS = [
  OrderAnalysisPageComponent,
  OrderBudgetModalComponent,
  OrderCopyModalComponent,
  OrderEditPageComponent,
  OrderInformationPageComponent,
  OrderItemPageComponent,
  OrderListFiltersComponent,
  OrderListPageComponent,
  OrderQuickLineItemFormComponent
];

@NgModule({
  imports: [
    AdvertisingSharedModule,
    CreativeModule,
    LineItemModule
  ],
  declarations: ORDER_COMPONENTS,
  exports: ORDER_COMPONENTS
})
export class OrderModule {
}
